/**
=========================================================
* Sagres Rotas React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Sagres Rotas React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import Button from "@mui/material/Button";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/login-bg.jpg";

import { MobXProviderContext } from "mobx-react";
import MDSnackbar from "components/MDSnackbar";

function Basic() {
  const [errorAlert, setErrorAlert] = useState(false);
  const { loginStore } = React.useContext(MobXProviderContext);
  const navigate = useNavigate();

  const openErrorAlert = () => setErrorAlert(true);
  const closeErrorAlert = () => setErrorAlert(false);

  const handleOnClick = (e) => {
    e.preventDefault();
    loginStore
      .fazerLogin()
      .then(() => {
        if (loginStore.error === "") {
          navigate("/mapa");
        }
      })
      .catch(() => {
        openErrorAlert();
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Impede o comportamento padrão de submit
      handleOnClick(e);    // Chama a função de login
    }
  };

  const renderErrorAlert = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Erro"
      content={loginStore.error ?? ""}
      dateTime="agora"
      open={errorAlert}
      onClose={closeErrorAlert}
      close={closeErrorAlert}
      bgWhite
    />
  );

  return (
    <BasicLayout image={bgImage}>
      <Card>
        {renderErrorAlert}
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Login
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Login"
                fullWidth
                onChange={(v) => loginStore.setLogin(v.target.value)}
                onKeyDown={handleKeyDown} // Adiciona o evento de tecla
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Senha"
                fullWidth
                onChange={(v) => loginStore.setSenha(v.target.value)}
                onKeyDown={handleKeyDown} // Adiciona o evento de tecla
              />
            </MDBox>
            <MDBox mt={4} mb={1} textAlign="center">
              <Button fullWidth color="primary" variant="contained" onClick={handleOnClick}>
                <MDTypography variant="h5" fontWeight="medium" color="white">
                  Entrar
                </MDTypography>
              </Button>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;

